const POLL_INTERVAL_MS = 50;
const DEFAULT_TIMEOUT_MS = 3000;

type ApplePaySessionStatic = {
  canMakePayments?: () => boolean;
  supportsVersion?: (version: number) => boolean;
};

export const getApplePaySession = (): ApplePaySessionStatic | undefined => {
  if (typeof window === 'undefined') return undefined;
  return (window as unknown as { ApplePaySession?: ApplePaySessionStatic })
    .ApplePaySession;
};

const sleep = (ms: number): Promise<void> =>
  new Promise((resolve) => setTimeout(resolve, ms));

export const waitForApplePaySdk = async (
  timeoutMs = DEFAULT_TIMEOUT_MS
): Promise<boolean> => {
  if (getApplePaySession()) return true;
  if (typeof window === 'undefined') return false;

  // ApplePaySession injetado async pelo script da Apple (sem evento de load p/ ouvir);
  // em rede lenta ele chega depois do mount, daí o polling até o timeout.
  const deadline = Date.now() + timeoutMs;
  while (Date.now() < deadline) {
    await sleep(POLL_INTERVAL_MS);
    if (getApplePaySession()) return true;
  }

  return false;
};

export const canMakeApplePayments = (): boolean => {
  try {
    return !!getApplePaySession()?.canMakePayments?.();
  } catch {
    return false;
  }
};

const SUPPORTED_VERSIONS = [10, 9, 8, 6, 4, 3];
const FALLBACK_VERSION = 3;

export const pickApplePayVersion = (): number =>
  SUPPORTED_VERSIONS.find((version) =>
    getApplePaySession()?.supportsVersion?.(version)
  ) ?? FALLBACK_VERSION;
